export enum BookingSessionConsent {
  GoogleAnalytics = 'analytics',
}

export default interface BookingSession {
  id: string;
  storeId: string;
  services: string[];
  collections: string[];
  masterclassRef?: string;
  watchesRef: string[];
  jewelleryRef: string[];
  strapsRef: string[];
  consents: string[];
  message: string;
  language: string;
}
